import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import {IntegrationService} from "../services/integration.service";
import {StorageService} from "../services/storage.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  integrations: any[] = [];
  user: any;

  constructor(
    private userService: UserService,
    private integrationService: IntegrationService,
    private storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.user = this.storageService.getUser();
    this.integrationService.getIntegrations().then((integrations: any) => {
      const customerIntegrations = this.storageService.getCustomerIntegrations();
      if (customerIntegrations) {
        integrations = integrations.map((integration: any) => {
          const customerIntegration = customerIntegrations.find((ci: any) => ci.type === integration.id);
          if (customerIntegration) {
            integration.customerIntegrationId = customerIntegration.id;
            integration.usedByCustomer = customerIntegration.active;
          }
          return integration;
        });
      }
      this.integrations = integrations;
    });
  }
}
